import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";
const Mauhopdongct = React.memo(function Mauhopdongct(props) {
  const classes = useStyles();
  const { hopdong_id } = props;
  const [tendonvi, setTendonvi] = React.useState("");
  const [ten_dvthue, setTen_dvthue] = React.useState("");
  const [diachi_dvthue, setDiachi_dvthue] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (hopdong_id > 0) {
      var url =
        Config.backend +
        "/api/phuongtien/gethopdongvantaitheoid?id=" +
        hopdong_id +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          console.log(data[0].diachi_dvthue);
          if (data[0].tendonvi) setTendonvi(data[0].tendonvi);
          if (data[0].ten_dvthue) setTen_dvthue(data[0].ten_dvthue);
          if (data[0].diachi_dvthue) setDiachi_dvthue(data[0].diachi_dvthue);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [hopdong_id]);
  return (
    <GridContainer style={{ overflow: "auto", height: 600 }}>
      <GridItemLogin xs={12} sm={12} md={1}></GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={10}>
        <GridContainer style={{ border: "0.1px solid #4f7edb" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <a className={classes.tieudecenter}>
                THÔNG BÁO NỘI DUNG HỢP ĐỒNG VẬN CHUYỂN
              </a>
              <a className={classes.tieudecenter}>
                Kính gửi: Sở Xây dựng Tỉnh Gia Lai
              </a>
              <a className={classes.tieudeleftbold}>
                I. Thông tin về đơn vị kinh doanh vận tải ký hợp đồng:
              </a>
              <a className={classes.tieudeleftbold}>
                1. Tên đơn vị kinh doanh vận tải: {tendonvi}
              </a>
              <a className={classes.tieudeleft}>2. Địa chỉ:</a>
              <a className={classes.tieudeleft}>
                3. Số điện thoại (Fax):....Mã số thuế:
              </a>
              <a className={classes.tieudeleft}>
                4. Người đại diện ký hợp đồng:
              </a>
              <a className={classes.tieudeleftbold}>II. Thông tin về lái xe:</a>
              <a className={classes.tieudeleft}>1. Họ và tên:</a>
              <a className={classes.tieudeleft}>2. Số điện thoại:</a>
              <a className={classes.tieudeleftbold}>
                III. Thông tin về người thuê vận tải:
              </a>
              <a className={classes.tieudeleft}>
                1. Tên đơn vị (cá nhân): {ten_dvthue}
              </a>
              <a className={classes.tieudeleft}>2. Địa chỉ: {diachi_dvthue}</a>
              <a className={classes.tieudeleft}>
                3. Số điện thoại:....Mã số thuế (nếu có):
              </a>
              <a className={classes.tieudeleftbold}>
                IV. Thông tin về phương tiện vận chuyển:
              </a>
              <a className={classes.tieudeleft}>
                1. Biểm kiểm soát xe:....2. Sức chứa:
              </a>
              <a className={classes.tieudeleftbold}>
                V. Thông tin về thực hiện hợp đồng:
              </a>
              <a className={classes.tieudeleft}>
                1. Thời gian bắt đầu thực hiện và kết thúc hợp đồng (ghi rõ giờ,
                ngày tháng năm):
              </a>
              <a className={classes.tieudeleft}>
                2. Địa chỉ điểm đầu, điểm cuối và các điểm đón, trả khách:
              </a>
              <a className={classes.tieudeleft}>3. Hành trình:</a>
              <a className={classes.tieudeleft}>
                4. Cự ly của hành trình vận chuyển (km):
              </a>
              <a className={classes.tieudeleft}>5. Các nội dung khác:</a>
            </FormControl>
          </GridItem>
        </GridContainer>
      </GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={1}></GridItemLogin>
    </GridContainer>
  );
});

Mauhopdongct.propTypes = {
  hopdong_id: PropTypes.number,
};
export default Mauhopdongct;
